import { render, staticRenderFns } from "./LowestCostPlanLabel.vue?vue&type=template&id=84d58f4a"
import script from "./LowestCostPlanLabel.vue?vue&type=script&lang=js"
export * from "./LowestCostPlanLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports